<!-- <div style="position: relative;">
    <header>
        <div class="header" style="display:block">
            <label>{{heading}}</label>
        </div>
    </header>

    <div style="overflow-y:scroll;height:78%;width:100%">
        <form [formGroup]="addForm" (ngSubmit)="submitForm()">
            <div class="container">
                <div class="row col-md-12">
                    <div class="col-3">
                        <label class="form-label">Order</label>
                        <div class="fontBold"> {{this.order}}</div>
                    </div>
                    <div class="col-3">
                        <label class="form-label">Sub Route</label>
                        <div class="fontBold"> {{this.subRoute}}</div>
                    </div>
                    <div class="col-2">
                        <label class="form-label">Plan</label>
                        <span>
                            <input style="width: 60px;" type="text" formControlName="plan" class="form-control">
                        </span>
                    </div>
                    <div class="col-4">
                        <label class="form-label fontBold">Delete Unique serials Unloaded Picked</label>
                        <div class="fontBold"> {{this.dusuPicked}}</div>
                    </div>
                </div>
                <br>
                <br>
                <div class="row col-md-12">
                    <div class="col-3">
                        <label class="form-label">Supplier</label>
                        <div class="fontBold"> {{this.supplier}}</div>
                    </div>
                    <div class="col-3">
                        <label class="form-label">Unload Date</label>
                        <div class="fontBold"> {{this.uDate}}</div>
                    </div>
                    <div class="col-2">
                        <label class="form-label">Unloaded</label>
                        <div class="fontBold"> {{this.unloaded}}</div>
                    </div>
                    <div class="col-4">
                        <label class="form-label">Plant-Dock</label>
                        <div class="fontBold"> {{this.pDock}}</div>
                    </div>
                </div>
                <br>
                <br>
                <div class="row col-md-12">
                    <div class="col-3">
                        <label class="form-label">Main Route</label>
                        <div class="fontBold"> {{this.mRoute}}</div>
                    </div>
                    <div class="col-3">
                        <label class="form-label">Picked</label>
                        <div class="fontBold"> {{this.picked}}</div>
                    </div>
                    <div class="col-2">
                        <label class="form-label">Load Date</label>
                        <div class="fontBold"> {{this.loadDate}}</div>
                    </div>
                    <div class="col-4">
                        <label class="form-label">ByPass
                            <input type="checkbox" class="small-square" id="square-1">
                        </label>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <!-- <div class=" footer">
    <button mat-raised-button type="submit" class="submit" style="display: inline;"
        (click)="submitForm()">SUBMIT</button>
    <button mat-raised-button type="submit" class="clearBtn" style="display: inline;" (click)="clearHistory()">Clear
        History</button>
    <button (click)="onClick()" class="cancel"
        style="display: inline; background: transparent;border: none !important;"> CANCEL </button>
</div> -->

    <!-- <div class="footerp cfooter" style="top: 510px;">

        <button mat-raised-button type="submit" class="submit" style="display: inline;width: 88px;
        height: 40px;position: relative;left: -50px;"
            (click)="submitForm()">SUBMIT</button>
        <button mat-raised-button type="submit" class="addprimarybtn" style="display: inline;width: 133px;
        height: 38px;left: -42px; position: relative;" (click)="clearHistory()">Clear
            History</button>
        <label class="cancel" style="position: relative;
        right: 27px;top:5px" (click)="onClick()"> CANCEL
        </label>
    </div>

</div> --> -->